import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  {
    icon: 'ri-file-search-line',
    title: 'Nous analysons votre demande',
    delay: 0,
  },
  {
    icon: 'ri-team-line',
    title: 'Nous vous mettons en relation avec 1 à 3 couvreurs partenaires qualifiés',
    delay: 150,
  },
  {
    icon: 'ri-phone-line',
    title: 'Ils vous appellent sous 2h ouvrables pour une soumission gratuite',
    delay: 300,
  },
];

export default function Etapes() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section className="bg-soft-gray py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            Que se passe-t-il maintenant ?
          </h2>
          <p className="text-slate-primary/50 text-sm md:text-base">
            Voici les prochaines étapes en 3 clics
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl p-6 md:p-8 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${step.delay}ms` }}
            >
              <div className="w-14 h-14 bg-copper/10 rounded-full flex items-center justify-center mx-auto mb-5">
                <i className={`${step.icon} text-copper text-2xl`} />
              </div>
              <span className="inline-block bg-copper/10 text-copper text-xs font-bold tracking-wide uppercase px-3 py-1 rounded-full mb-4">
                Étape {idx + 1}
              </span>
              <p className="text-slate-primary font-semibold text-sm md:text-base leading-relaxed">
                {step.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}